/* eslint-disable no-console */
import React from 'react';
import ReactDOM from 'react-dom';

export const getComponentDetailsFromDOM = (componentName) => {
  try {
    const targetNodeList = document.querySelectorAll(`[data-component="${componentName}"]`);
    const targetNodeArray = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0, ll = targetNodeList.length; i !== ll; targetNodeArray.push(targetNodeList[i++]));
    if (targetNodeArray && targetNodeArray.length) {
      return targetNodeArray.map((targetNode) => {
        const props = targetNode.getAttribute('data-props');
        return {
          targetNode,
          props: props ? JSON.parse(props) : {},
        };
      });
    }
  } catch (err) {
    console.error('There was an error when getting component details from DOM for:', { componentName, err });
    return false;
  }
  return false;
};

export const dynamicRender = ({
  componentName,
  getComponent,
  eventListener,
  isHydrate,
}) => {
  const componentDetailsList = getComponentDetailsFromDOM(componentName);
  if (componentDetailsList && componentDetailsList.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = componentDetailsList.length; i < len; i++) {
      const { targetNode, props } = componentDetailsList[i];
      getComponent()
        .then((module) => {
          const Component = module[componentName];
          try {
            if (isHydrate) {
              ReactDOM.hydrate(<Component {...props} />, targetNode);
            } else {
              ReactDOM.render(<Component {...props} />, targetNode);
            }
          } catch (err) {
            console.error('Dynamically loaded component is not valid:', { componentName, err }, Component);
          }
        })
        .catch((err) => {
          console.error('Could NOT load the component dynamically:', { componentName, err });
        });
    }
  }
  if (eventListener) {
    document.addEventListener(eventListener, () => {
      dynamicRender({ componentName, getComponent, isHydrate });
    });
  }
};

export const staticRender = ({
  componentName,
  getComponent,
}) => {
  getComponent().then(async (module) => {
    const Component = module[componentName];
    // Only try to mount if the file contains a component with the same name. Otherwise just import / chunk it.
    // Useful for files that only import css chunks (e.g. PDP, PLP pages)
    if (Component) {
      const targetNode = document.getElementById('root');
      const props = await (module.getStaticProps ? module.getStaticProps() : {});
      ReactDOM.render(<Component {...props} />, targetNode);

      window.snapSaveState = () => {
        targetNode.removeAttribute('id');
        targetNode.setAttribute('data-component', componentName);
        targetNode.setAttribute('data-props', JSON.stringify(props));
      };
    }
  });
};
